import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default {
    install(app) {
        app.config.globalProperties.$dayjs = dayjs;
    }
}
